import React, {useEffect} from "react";
import UpcomingEventsSideView from "./Components/UpcomingEventsSideView";
import DashboardContent from "./Components/DashboardContent";
import { useDispatch } from "react-redux";
import { authActions } from "../../../../redux/actions";

const Dashboard = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authActions.fetchCities(process.env.REACT_APP_Country_Id));
  }, []);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-8 col-12">
            <DashboardContent />
          </div>
          <div className="col-md-4 col-12">
            <UpcomingEventsSideView />
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
